import { Navigate, useLocation } from 'react-router-dom'
import React from 'react'

import { ROUTES } from '../../../constants/routes'
import { charityAccountPath } from '../../../lib/charityProfileLink'

/**
 * Legacy bank-info registration route. Stripe Connect is the verification
 * path now — send bookmarks/deep links to charity account or My Charities.
 */
export default function CharityRegisterPage() {
  const location = useLocation()
  const charity = location.state?.charity
  const accountPath = charityAccountPath(charity?.id)

  if (accountPath) {
    return <Navigate to={accountPath} replace />
  }

  return <Navigate to={ROUTES.CHARITIES} replace />
}
